/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { withFormik } from 'formik';
import { Column } from 'rbx';
import * as yup from 'yup';
import swal from 'sweetalert';
import moment from 'moment';

import { FaAngleLeft } from 'react-icons/fa';
import DealTimeDatePicker from '../../../PlaceManagement/PlaceDealAdd/DealTimeDatePicker';

const Container = styled.form`
  &&& {
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      height: 100vh;
      padding: 0px;
    }
    .modal-card {
      max-height: calc(100vh - 0px);
      position: absolute;
      right: 0;
      width: 35rem;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      border-bottom: 0px;
      padding: 1rem 2rem;
      padding-top: 1.5rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: center;
      background: white;
      border-top: 0px;
      .button {
        font-weight: 600;
      }
    }
  }
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  left: 1rem;
  top: 1rem;
`;

const DetailsFormWrapper = styled.div`
  padding: 1rem 2rem;
`;

const Form = ({
  isActive,
  onClose,
  handleSubmit,
  resetForm,
  values,
  setFieldValue,
  errors,
  touched,
  adminUpdateMenuOrderLoading,
}) => (
  <Container className={`modal ${isActive && 'is-active'}`}>
    <div className="modal-background" />
    <div className="modal-card">
      <header className="modal-card-head">
        <p
          className="modal-card-title is-flex"
          style={{ justifyContent: 'center' }}
        >
          Update Order
        </p>

        <CloseButtonWrapper>
          <FaAngleLeft
            size={30}
            type="button"
            onClick={() => {
              onClose();
              resetForm();
            }}
          />
        </CloseButtonWrapper>
      </header>

      <section className="modal-card-body">
        <DetailsFormWrapper>
          <Column.Group>
            <div className="column">
              <DealTimeDatePicker
                label="Schedule Date"
                timeLabel="Schedule Time"
                date={values.scheduledDate}
                time={values.scheduledTime}
                onDateChange={value => {
                  setFieldValue('scheduledDate', value);
                }}
                onTimeChange={value => {
                  setFieldValue('scheduledTime', value ? moment(value) : null);
                }}
                errors={errors.scheduledDate}
                touched={touched.scheduledDate}
                required
              />
            </div>
          </Column.Group>
        </DetailsFormWrapper>
      </section>
      <footer className="modal-card-foot">
        <button
          className={`button is-large is-fullwidth is-primary ${adminUpdateMenuOrderLoading &&
            'is-loading'}`}
          onClick={handleSubmit}
        >
          UPDATE ORDER
        </button>
      </footer>
    </div>
  </Container>
);

const TimingUpdate = withFormik({
  mapPropsToValues: ({ order }) => {
    const raw = order && order.scheduled_date_time;
    const scheduledDateTime = raw && moment(raw).isValid() ? moment(raw) : null;
    return {
      scheduledDate: scheduledDateTime ? scheduledDateTime.toISOString() : null,
      scheduledTime: scheduledDateTime || null,
    };
  },

  validationSchema: yup.object().shape({
    scheduledDate: yup
      .string()
      .nullable()
      .required('Schedule date is required'),
  }),

  handleSubmit: (values, { props }) => {
    const customDate = moment(values.scheduledDate).format('YYYY-MM-DD');
    const customTime = values.scheduledTime
      ? moment(values.scheduledTime).format('HH:mm:ss')
      : '00:00:00';
    const scheduledDateTime = moment(
      `${customDate} ${customTime}`,
    ).toISOString();

    swal({
      title: 'Are you sure to update the order?',
      buttons: ['Cancel', 'Confirm'],
    }).then(async isConfirm => {
      if (isConfirm) {
        await props.adminUpdateMenuOrder({
          variables: {
            input: {
              menu_order_id: props.order.menu_order_id,
              user_id: props.userId,
              scheduled_date_time: scheduledDateTime,
              estimated_completion_time: scheduledDateTime,
            },
          },
        });
      }
    });
  },

  displayName: 'TimingUpdate',
})(Form);

export default TimingUpdate;
